export interface GlobalHeaderScriptElement {
  attributes: Record<string, string>;
  content: string;
}

const SCRIPT_ELEMENT = /<script\b([^>]*)>([\s\S]*?)<\/script\s*>/gi;
const ATTRIBUTE = /([^\s=/>]+)(?:\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s"'>]+)))?/g;

const JSON_LD_TYPE = 'application/ld+json';

const parseAttributes = (raw: string): Record<string, string> => {
  const attributes: Record<string, string> = {};
  for (const match of raw.matchAll(ATTRIBUTE)) {
    const name = match[1].toLowerCase();
    attributes[name] = match[2] ?? match[3] ?? match[4] ?? '';
  }
  return attributes;
};

export const parseGlobalHeaderScripts = (blob: string | undefined | null): GlobalHeaderScriptElement[] => {
  if (!blob) return [];

  return [...blob.matchAll(SCRIPT_ELEMENT)].map((match) => ({
    attributes: parseAttributes(match[1]),
    content: match[2],
  }));
};

export const isJsonLd = ({ attributes }: GlobalHeaderScriptElement): boolean =>
  attributes.type?.trim().toLowerCase() === JSON_LD_TYPE;
